import { Button, ButtonProps } from "antd";
import { FC, useState } from "react";
import { renderErrorMessage } from "../../../../components/messages/errorMessage";
import LeasingStore from "../../../../contexts/leasingStore";
import _t from "../../../../lang/translate";
import { checkMotorAgencyStatus } from "../../../../services/leasingService";
import Icon from "../../../../assets/icons/icon";

const MotorAgencyReportCheck: FC<ButtonProps> = (props) => {
  const [loading, setLoading] = useState<boolean>(false);
  const { leasingCase, adminValues, setAdminValues } = LeasingStore.useContainer();
  const vin = leasingCase.vehicle?.vin;

  const handleCheck = async () => {
    if (!vin) return;
    try {
      setLoading(true);
      const { data } = await checkMotorAgencyStatus(leasingCase.id);
      adminValues && setAdminValues({ ...adminValues, motorAgency: data });
    } catch (error) {
      renderErrorMessage(error)
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button icon={<Icon name="sync-outline" />} {...props} loading={loading} onClick={handleCheck}>
      {_t("check", "DMR")}
    </Button>
  );
};

export default MotorAgencyReportCheck;
